var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchAlterar, fetchResource, fetchConsultarPaginada } from '../../../api';
var ROTA_BASE = 'reeducandos-pontos/fechamento-mensal';
// ---------------------------------------------------------------------------
// Funções de serviço
// ---------------------------------------------------------------------------
/**
 * Busca as folhas da fila de análise FUNAC.
 *
 * GET /reeducandos-pontos/fechamento-mensal/fila-analise
 */
export var getFilaAnalise = function (pagination, filtros) { return __awaiter(void 0, void 0, Promise, function () {
    var params, qs, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                params = new URLSearchParams();
                if (filtros.fiscal_local_id) {
                    params.append('fiscal_local_id', String(filtros.fiscal_local_id));
                }
                params.append('instituicao_id', String(filtros.instituicao_id));
                if (filtros.ano_referencia)
                    params.append('ano_referencia', String(filtros.ano_referencia));
                if (filtros.mes_referencia)
                    params.append('mes_referencia', String(filtros.mes_referencia));
                if (filtros.nome)
                    params.append('nome', filtros.nome);
                if (filtros.matricula)
                    params.append('matricula', filtros.matricula);
                if (filtros.status)
                    params.append('status', filtros.status);
                qs = params.toString();
                url = "".concat(ROTA_BASE, "/fila-analise?").concat(qs);
                return [4 /*yield*/, fetchConsultarPaginada(url, pagination)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Busca o detalhamento de uma justificativa no contexto da fila de análise FUNAC.
 *
 * GET /reeducandos-pontos/fechamento-mensal/:folhaId/justificativas/:justificativaId
 */
export var getJustificativaFolhaFunac = function (folhaId, justificativaId) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/").concat(folhaId, "/justificativas/").concat(justificativaId);
                return [4 /*yield*/, fetchResource(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// ---------------------------------------------------------------------------
// Funções de escrita
// ---------------------------------------------------------------------------
/**
 * Devolve uma folha ao Fiscal Local para correção.
 *
 * PATCH /reeducandos-pontos/fechamento-mensal/fila-analise/:id/devolver
 */
export var devolverFolhaFunac = function (folhaId, motivo_devolucao) { return __awaiter(void 0, void 0, Promise, function () {
    var url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/fila-analise/").concat(folhaId, "/devolver");
                return [4 /*yield*/, fetchAlterar(url, { motivo_devolucao: motivo_devolucao })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Conclui a análise de uma folha (status → ANALISADA).
 *
 * PATCH /reeducandos-pontos/fechamento-mensal/fila-analise/:id/concluir
 */
export var concluirAnaliseFunac = function (folhaId, observacao) { return __awaiter(void 0, void 0, Promise, function () {
    var url, body;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(ROTA_BASE, "/fila-analise/").concat(folhaId, "/concluir");
                body = {};
                if (observacao === null || observacao === void 0 ? void 0 : observacao.trim())
                    body.observacao = observacao.trim();
                return [4 /*yield*/, fetchAlterar(url, body)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
